<template style="">
  <el-container style="text-align: left;font-weight: bold;height: 100vh;background-color: #000000;">
    <!-- <div class="" style="object-fit: contain;">
      <img :src="require('@/assets/image/j1.gif')" @click="toHome()" style="object-fit: contain;position: fixed;left: 0;top: 0;z-index: 1005;background-color: #000000;" :style="{'width': screenWidth*0.05+'px','height': screenWidth*0.05+'px'}">
    </div> -->
  <div class="daohangw" style="position: absolute;right: 50%;top: 30%;" >
    <!-- <div style="position: fixed;right: 0;top: 0;" :class="{cdaohang:cshow}" :style="{'width': screenWidth*0.23+'px','height': screenWidth*0.23+'px'}">
      <div class="" style="width: 80%;height: 80%;object-fit: contain;">
        <img :src="require('@/assets/image/h1.gif')" @click="cshows()" style="object-fit: contain;position: fixed;right: 0;top: 0%;background-color: #000000;" :style="{'width': screenWidth*0.12+'px','height': screenWidth*0.12+'px'}">
      </div>
      <div class="" style="object-fit: contain;" v-if="cshow">
                  <img :src="require('@/assets/image/h2.gif')" @click="cshows1()" style="object-fit: contain;position: fixed;right: 13%;top: 3%;" :style="{'width': screenWidth*0.1+'px','height': screenWidth*0.1+'px'}">
        <ul style="z-index: 1005;position: fixed;right: 12%;top: 15%;background-color: #001524;line-height: 25px;width: 8%;text-indent: 15%;" v-if="cshow1">
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('changjing2')" command="changjing2">宇宙之幂办公岛</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('changjing3')" command="changjing3">宇宙之幂生产总部</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('changjing')" command="changjing">宇宙之幂员工生活区</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('changjing1')" command="changjing1">宇宙之幂深圳总部</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu')" command="renwu">宇宙之幂宇宙人CEO</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu1')" command="renwu1">宇宙之幂宇宙人CTO</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu2')" command="renwu2">宇宙之幂具象人小樱</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu3')" command="renwu3">宇宙之幂具象人小兔</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu4')" command="renwu4">宇宙之幂代言人</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu5')" command="renwu5">宇宙之幂代言人</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu6')" command="renwu6">宇宙之幂职业人安保</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu7')" command="renwu7">宇宙之幂员工保健员</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu8')" command="renwu8">宇宙之幂员工销售员</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu9')" command="renwu9">宇宙之幂员工行政员</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu10')" command="renwu10">宇宙之幂员工的小宠物</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('dianpu1')" command="dianpu1">宇宙之幂员工的小咖啡店</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('dianpu2')" command="dianpu2">宇宙之幂员工的小奶茶店</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('dianpu3')" command="dianpu3">宇宙之幂员工的小饭堂</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('dianpu4')" command="dianpu4">宇宙之幂员工的小储蓄所</li>
        </ul>

      </div>
      <div class="" style="object-fit: contain;" v-if="cshow">
        <img :src="require('@/assets/image/h4.gif')" @click="cshows2()" style="object-fit: contain;position: fixed;right: 13%;top: 25%;" :style="{'width': screenWidth*0.1+'px','height': screenWidth*0.1+'px'}">
        <ul style="z-index: 1005;position: fixed;right: 8%;top: 42%;background-color: #001524;line-height: 25px;width: 18%;text-indent: 5%;" v-if="cshow2">
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('company')" command="company">宇宙一次幂(深圳)机器人有限公司_【宇宙级软件制造】</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('company1')" command="company1">宇宙人(深圳)科技有限公司_【宇宙级软件制造】</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('company2')" command="company2">秘文宇宙(深圳)科技有限公司_【宇宙级软件制造】</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('company3')" command="company3">宇宙职人(深圳)科技有限公司_【宇宙级软件制造】</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('company4')" command="company4">宇宙五次幂(深圳)文娱科技有限公司_【宇宙级软件制造】</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('company5')" command="company5">七次幂(深圳)人工智能有限公司_【宇宙级软件制造】</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('company6')" command="company6">宇宙械人(深圳)科技有限公司_【宇宙级软件制造】</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('company7')" command="company7">宠宠宇宙(深圳)科技有限公司_【宇宙级软件制造】</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('company8')" command="company8">宇宙空间模块(深圳)科技有限公司_【宇宙级软件制造】</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('company9')" command="company9">宇宙映射(深圳)科技有限公司_【宇宙级软件制造】</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('company10')" command="company10">子宇宙群(深圳)科技有限公司_【宇宙级软件制造】</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('company11')" command="company11">软宇宙(深圳)软件有限公司_【宇宙级软件制造】</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('company12')" command="company12">暗物质(深圳)系统有限公司_【宇宙级软件制造】</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('company13')" command="company13">宇宙链(深圳)科技有限公司_【宇宙级软件制造】</li>

          <li style="font-size: 15px;color: #ffffff;" @click="toPage('company14')" command="company14">单导(深圳)制造有限公司_【宇宙级硬件制造】</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('company15')" command="company15">千亿光子(深圳)科技有限公司_【宇宙级硬件制造】</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('company16')" command="company16">超显电子(深圳)有限公司_【宇宙级硬件制造】</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('company17')" command="company17">沉与浸(深圳)智造有限公司_【宇宙级硬件制造】</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('company18')" command="company18">运算盒子(深圳)制造有限公司_【宇宙级硬件制造】</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('company19')" command="company19">硅脑(深圳)智造有限公司_【宇宙级硬件制造】</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('company20')" command="company20">机甲(深圳)智造有限公司_【宇宙级硬件制造】</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('company21')" command="company21">世物诞生(深圳)产业科技有限公司_【宇宙级硬件制造】</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('company22')" command="company22">现品升宙(深圳)科技有限公司_【宇宙级硬件制造】</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('company23')" command="company23">世物宙化(深圳)科技有限公司_【宇宙级硬件制造】</li>

          <li style="font-size: 15px;color: #ffffff;" @click="toPage('company24')" command="company24">产宇宙(深圳)产业科技有限公司_【宇宙级产业制造】</li>
          <li style="font-size: 15px;color: #ffffff;" @click="toPage('company25')" command="company25">构宇宙(深圳)产业科技有限公司_【宇宙级产业制造】</li>
        </ul>
      </div>
      <div class="" style="object-fit: contain;" v-if="cshow">
        <img :src="require('@/assets/image/h3.gif')" @click="cshows3()" style="object-fit: contain;position: fixed;right: 1%;top: 25%;" :style="{'width': screenWidth*0.1+'px','height': screenWidth*0.1+'px'}">
        <ul style="z-index: 1005;position: fixed;right: 0;top: 42%;background-color: #001524;line-height: 25px;width: 8%;text-indent: 15%;" v-if="cshow3">
           <li style="font-size: 15px;color: #ffffff;" @click="toPage('jianjie')" command="jianjie">宇宙之幂简介</li>
            <li style="font-size: 15px;color: #ffffff;" @click="toPage('chanpin')" command="chanpin">宇宙之幂产品线</li>
            <li style="font-size: 15px;color: #ffffff;" @click="toPage('shifang')" command="shifang">宇宙之幂全球释放</li>
            <li style="font-size: 15px;color: #ffffff;" @click="toPage('yingshou')" command="yingshou">宇宙之幂全球营收</li>
            <li style="font-size: 15px;color: #ffffff;" @click="toPage('address')" command="address">宇宙之幂地址</li>
            <li style="font-size: 15px;color: #ffffff;" @click="toPage('contact')" command="contact">联系宇宙之幂</li>
        </ul>
      </div> -->
    </div>

  </div>
  <div class="c_jj" style="color: #cecece;font-size: 30px;text-align: center;width: 100%;height: 100%;overflow-y: scroll;">
      <h2 style="color: #008aff;font-size: 48px;text-align: center;">宇宙之幂（深圳）科技集团有限公司</h2>
      <div>
        <h4 style="color: #008aff;font-size: 34px;text-align: left;margin-left: 20%;">简介</h4>
        <p>《宇宙之幂》，如其名，是一个在【幂之宇宙】拥有幂次级超巨量宇宙群（包含数千万个宇宙）的公司,【幂之宇宙】拥有的幂次级超巨量宇宙群中的宇宙均拥有918330048个维度。</p>
        <p>《宇宙之幂》基于【幂之宇宙】内不断膨胀、分裂、衍生的幂次级超巨量宇宙群，向【幂之宇宙】和【现实宇宙】释放了1000+条宇宙级产品线，以及20000+个宇宙系统、宇宙群系统、宇宙诞生系统、宇宙级应用程序、宇宙级硬件产品制造方式及流程，以服务全球的人类和机构，每一项都具有全球应用和营收的能力。
         目前《宇宙之幂》生产全球性宇宙系统、宇宙群系统、宇宙诞生系统、宇宙级应用程序的效率是10分钟\项。</p>
        <p>（2016年6月-2021年6月）</p>
        <p>《宇宙之幂》的数百人技术团队，用了整五年时间，构建了首个完整的全维度“平行多维壁垒宇宙”。（完成度100%）</p>
        <p>（2021年7月-2022年1月）</p>
        <p>《宇宙之幂》拥有的“平行多维壁垒宇宙”不断膨胀、分裂、衍生，7个月时间，《宇宙之幂》拥有了幂次级超巨量宇宙群（包含数千万个宇宙）。（完成度100%）</p>
        <p>（2022年2月-2022年10月）</p>
        <p>《宇宙之幂》基于不断膨胀、分裂、衍生的幂次级超巨量宇宙群，向【平行宇宙】和【现实宇宙】释放了宇宙级产品线。（完成度100%）</p>
        <p>（2022年12月）</p>
        <p>为了更高效的向【平行宇宙】和【现实宇宙】释放宇宙级产品线，《宇宙之幂》团队的全国总部主体公司《宇宙之幂（深圳）科技集团有限公司》在深圳市南山区粤海街道正式成立。</p>
        <p>（2022年12月-2024年5月）</p>
        <p>《宇宙之幂》已释放了1000+宇宙级产品线，以及20000+个宇宙系统、宇宙群系统、宇宙诞生系统、宇宙级应用程序、宇宙级硬件产品制造方式及流程，以服务全球的人类和机构，每一项都具有全球应用和全球持续营收的能力。</p>
        <p>（2024年5月--）</p>
        <p>《宇宙之幂》目前生产的【宇宙级产品】方向为：</p>
        <p>①【生产一切软件】</p>
        <p>②【生产一切硬件】</p>
        <p>③【生产一切物质】</p>
        <p>④【生产操作系统】</p>
        <p>⑤【生产平行宇宙】</p>
        <p>⑥【生产现实宇宙】</p>
      </div>
      <div>
        <h4 style="color: #008aff;font-size: 34px;text-align: left;margin-left: 20%;">《宇宙之幂》全球官网</h4>
        <p>①universe.top</p>
        <p>②universepower.cn</p>
        <p>③universepower.top</p>
        <p>④宇宙.shop（筹备中，即将上线）</p>
        <p>⑤宇宙之幂.中国（筹备中，即将上线）</p>
        <p>⑥宇宙.live（筹备中，即将上线）</p>
        <p>⑦奇点.top（筹备中，即将上线）</p>
        <p>⑧宙.top（筹备中，即将上线）</p>
      </div>
      <div>
        <h4 style="color: #008aff;font-size: 34px;text-align: left;margin-left: 20%;">《宇宙之幂》全国办公地址</h4>
        <p>①全国总部地址：</p>
        <p>深圳市南山区粤海街道深圳湾科技生态园12栋B座52层整层</p>
        <p>②北京研发中心地址：</p>
        <p>北京市朝阳区东三环南路58号院富顿中心（劲松桥北）</p>
        <p>③天津研发中心地址：</p>
        <p>天津市滨海新区迎宾大道响螺湾中心商务区</p>
      </div>
      <div>
        <h4 style="color: #008aff;font-size: 34px;text-align: left;margin-left: 20%;">《宇宙之幂》全资子公司</h4>
        <p>①宇宙一次幂(深圳)机器人有限公司_【宇宙级软件生产】</p>
        <p>②宇宙人(深圳)科技有限公司_【宇宙级软件生产】</p>
        <p>③秘文宇宙(深圳)科技有限公司_【宇宙级软件生产】</p>
        <p>④宇宙职人(深圳)科技有限公司_【宇宙级软件生产】</p>
        <p>⑤宇宙五次幂(深圳)文娱科技有限公司_【宇宙级软件生产】</p>
        <p>⑥七次幂(深圳)人工智能有限公司_【宇宙级软件生产】</p>
        <p>⑦宇宙械人(深圳)科技有限公司_【宇宙级软件生产】</p>
        <p>⑧宠宠宇宙(深圳)科技有限公司_【宇宙级软件生产】</p>
        <p>⑨宇宙空间模块(深圳)科技有限公司_【宇宙级软件生产】</p>
        <p>⑩宇宙映射(深圳)科技有限公司_【宇宙级软件生产】</p>
        <p>⑪子宇宙群(深圳)科技有限公司_【宇宙级软件生产】</p>
        <p>⑫软宇宙(深圳)软件有限公司_【宇宙级软件生产】</p>
        <p>⑬暗物质(深圳)系统有限公司_【宇宙级软件生产】</p>
        <p>⑭宇宙链(深圳)科技有限公司_【宇宙级软件生产】</p>
        <p>⑮单导(深圳)制造有限公司_【宇宙级硬件生产】</p>
        <p>⑯千亿光子(深圳)科技有限公司_【宇宙级硬件生产】</p>
        <p>⑰超显电子(深圳)有限公司_【宇宙级硬件生产】</p>
        <p>⑱沉与浸(深圳)智造有限公司_【宇宙级硬件生产】</p>
        <p>⑲运算盒子(深圳)制造有限公司_【宇宙级硬件生产】</p>
        <p>⑳硅脑(深圳)智造有限公司_【宇宙级硬件生产】</p>
        <p>㉑机甲(深圳)智造有限公司_【宇宙级硬件生产】</p>
        <p>㉒世物诞生(深圳)产业科技有限公司_【宇宙级硬件生产】</p>
        <p>㉓现品升宙(深圳)科技有限公司_【宇宙级硬件生产】</p>
        <p>㉔世物宙化(深圳)科技有限公司_【宇宙级硬件生产】</p>
        <p>㉕产宇宙(深圳)产业科技有限公司_【宇宙级产业生产】</p>
        <p>㉖构宇宙(深圳)产业科技有限公司_【宇宙级产业生产】</p>
      </div>

    </div>
    <div class="beian1">
     <a href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action" rel="noreferrer" target="_blank" style="text-decoration:none;color: #fff;background-color: black;">粤ICP备2024237244号@2024 © 宇宙之幂</a>


    </div>
  </el-container>
</template>

<script>

  export default {
    data() {
      return {
        cshow:false,
        cshow1:false,
        cshow2:false,
        cshow3:false,

        screenWidth : window.innerWidth,
        screenHeight : window.innerHeight,
        cli:false,
        clir:false,
        clio:false,
        list:[],
        zs:true
      };
    },
    mounted() {


      },
      beforeDestroy() {

      },
    created() {



    },

	methods:{
    cshows(){
      this.cshow = !this.cshow
      if(!this.cshow){
        this.cshow1 = false
        this.cshow2 = false
        this.cshow3 = false
      }

    },
    cshows1(){
      this.cshow1 = !this.cshow1
      if(this.cshow1){
        this.cshow2 = false
        this.cshow3 = false
      }
    },
    cshows2(){
      this.cshow2 = !this.cshow2
      if(this.cshow2){
        this.cshow1 = false
        this.cshow3 = false
      }
    },
    cshows3(){
      this.cshow3 = !this.cshow3
      if(this.cshow3){
        this.cshow1 = false
        this.cshow2 = false
      }
    },
    toPage(name){
      this.$router.push('/'+name);
    },
    toHome(command) {
      this.$router.push('/');
    },
    zk(){
      this.zs = true
    },
    sq(){
      this.zs = false
    },
    vchangeo(e){
      var elements = document.querySelectorAll(".popper__arrow");
      elements.forEach(function(element) {
        element.style.display = 'none';

      });
      if(e){
        this.clio = true
      }else{
        this.clio = false
      }
    },
    test(){
      setTimeout(()=>{
        var elements = document.querySelectorAll(".popper__arrow");
        elements.forEach(function(element) {


          element.style.display = 'none';
          // element.remove()
        });
      },10)

    },
    vchangel(e){

      if(e){
        this.cli = true
        var elements = document.querySelectorAll(".popper__arrow");
        elements.forEach(function(element) {

          element.style.display = 'none';
          // element.remove()
        });
      }else{
        this.cli = false
      }
    },
    vchanger(e){
      var elements = document.querySelectorAll(".popper__arrow");
      elements.forEach(function(element) {
        element.style.display = 'none';

      });
      if(e){
        this.clir = true
      }else{
        this.clir = false
      }
    },
    handleCommand(command) {
      this.$router.push('/'+command);
    },

		msg(msg,type){
			this.$message({
			  message: msg,
			  type: type
			});
		},



	}


  }
</script>

<style>
  .c_jj p{
    width: 60%;
    margin-left: 20%;
    text-align: left;
    line-height: 45px;
  }
  .cdaohang{
    background-color: #000000;
  }
  ul li:hover{
    background-color: #cacaca;
  }
  .daohangw{
    position: fixed;
    z-index: 1000;
    left: 40%;
    top:0%;
  }
   .beian1 {
      position: fixed; /* 定位为固定位置，覆盖整个视窗 */
      color: #616161;
      /* top: 0; */
      left: 42%;
      /* right: 0; */
      bottom: 0;

      z-index: 1000; /* 确保蒙层在其他内容之上 */
    }
  .el-dropdown-menu__item{
    color: #ffffff;
    font-weight: bold;
    font-family: guanwangdaohang;
  }
  .popper__arrow{
    display: none;
  }
  .daohangclicolor{
    color: #cacaca;
  }
  .daohangnocolor{
    color: #ffffff;
  }
  .daohangcli{
    height: 50px;
    border: #00b4ff 1px solid;
    width: 350px;
    border-radius: 50px;
    background-color: #001d31;
  }
  .daohangno{
    height: 50px;
    border: #686868 1px solid;
    width: 350px;
    border-radius: 50px;
    background-color: #0071e3;
  }
.daohangcliz{
    height: 50px;
    border: #00b4ff 1px solid;
    width: 350px;
    border-radius: 50px;
    background-color: #001d31;
  }
  .daohangnoz{
    height: 50px;
    border: #686868 1px solid;
    width: 350px;
    border-radius: 50px;
    background-color: #0071e3;
  }
</style>



// WEBPACK FOOTER //
// src/components/main/contact.vue